import { createLucideIcon } from 'lucide-react';

/** A dashed contour crossed by its long diameter and the short one across it. */
export default createLucideIcon('AxialDiameters', [
    [
        'ellipse',
        {
            cx: '12',
            cy: '12',
            rx: '10.5',
            ry: '7.5',
            transform: 'rotate(-35 12 12)',
            strokeDasharray: '2.6 2.6',
            strokeWidth: '1.5',
            key: 'contour',
        },
    ],
    ['path', { d: 'M3.4 18 20.6 6', key: 'long' }],
    ['path', { d: 'M9.3 9.2 13.8 15.6', key: 'short' }],
]);
